ixModuleRouting('impactx.tax', {
    '/taxeventlist': {
        template: '<ixa-tax-event-list></ixa-tax-event-list>',
        templateUrl: 'modules/tax/templates/taxeventlist.tmpl.html',
        controller: 'TaxEventListCtrl',
        controllerAs: 'taxEventListCtrl',
        workspace: 'admin'
    },
    '/taxevent/:id': {
        template: '<ixa-tax-event></ixa-tax-event>',
        templateUrl: 'modules/tax/templates/taxevent.tmpl.html',
        controller: 'TaxEventDialogCtrl',
        controllerAs: 'taxEventDialogCtrl',
        workspace: 'admin'
    },
    '/cc2taxeventlist': {
        template: '<ixa-cc2-tax-event-list></ixa-cc2-tax-event-list>',
        templateUrl: 'modules/tax/templates/cc2taxeventlist.tmpl.html',
        controller: 'CC2TaxEventListCtrl',
        controllerAs: 'cc2TaxEventListCtrl',
        workspace: 'admin'
    },
    '/cc2taxevent': {
        template: '<ixa-cc2-tax-event></ixa-cc2-tax-event>',
        templateUrl: 'modules/tax/templates/cc2taxevent.tmpl.html',
        controller: 'CC2TaxEventDialogCtrl',
        controllerAs: 'cc2TaxEventDialogCtrl',
        workspace: 'admin'
    }
});
